import { OnInit, ViewEncapsulation } from '@angular/core';
import { Component } from '@angular/core';
import { LayoutService } from './service/app.layout.service';
import { Role, Menu } from 'src/app/demo/interfaces/auth.inteface';
import { MegaMenuItem, MenuItem } from 'primeng/api';
import { AlertsService } from 'src/app/demo/service/alerts.service';
import { AuthService } from 'src/app/demo/service/auth.service';
import { Router } from '@angular/router';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { DialogValidityComponent } from 'src/app/demo/shared/dialog-validity/dialog-validity.component';
import { CrudService } from 'src/app/demo/service/crud.service';
import { StorageService } from '../utils/storage.service';

@Component({
    selector: 'app-menu',
    templateUrl: './app.menu.component.html',
    styleUrl: './app.menu.component.scss',
    encapsulation: ViewEncapsulation.None,
    providers: [
        DialogService
    ]
})
export class AppMenuComponent implements OnInit {
    model: Menu[] = [];
    roles: Role[] = [];
    items: MegaMenuItem[] = [];
    itemsToMenu: MenuItem[] = [];
    dynamicDialogRef: DynamicDialogRef | null = null;

    constructor(
        public layoutService: LayoutService,
        private alertService: AlertsService,
        private authService: AuthService,
        private router: Router,
        private dialogService: DialogService,
        private crudService: CrudService,
        private storage: StorageService
    ) { }

    ngOnInit() {
        this.getDataFromHttpOrCacheMenu();
    }

    /**
     * @author Ministerio de cultura
     * Método para obtener datos del menú desde el localStorage o realizar una consulta HTTP si no están en caché.
     * @createdate 2025-03-27
     */
    getDataFromHttpOrCacheMenu(): void {
		const starageKey: string = 'menu';
        const storageType = 'local';
        const $storage = this.storage.get<any>(starageKey, storageType);
        if ($storage) {
            this.processMenuData($storage);
        } else {
            this.crudService.postData({ url: 'menus/get_menu', formData: {} }).subscribe({
                next: (res) => {
                    this.storage.set(starageKey, res, storageType)
                    this.processMenuData(res);
                },
                error: (err) => {
                    console.error(`Error al obtener '${starageKey}' desde el servicio:`, err);
                },
            });
        }
    }

    /**
     * @author Ministerio de cultura
     * Procesa y ajusta los datos del menú según las necesidades de la aplicación.
     * @createdate 2025-03-27
     * @param data - Datos del menú obtenidos del servicio o del localStorage.
     */
    private processMenuData(data: any): void {
        this.itemsToMenu = this.adjustRouterLink(data.movil);
        this.items = this.transformMenuItems(this.itemsToMenu);
        this.itemsToMenu.push(
            { label: 'Vigencias', icon: 'pi pi-cog', command: () => { this.onClickShowValidities(); } },
            { label: 'Cerrar Sesión', icon: 'pi pi-sign-out', command: () => { this.onClickLogoutMenu(); } }
        );
    }

    /**
     * @author Ministerio de cultura
     * Modifica el router link si el padre del menu no tiene hijos.
     * @param items Array del menu.
     * @createdate 2024-12-27
    */
    adjustRouterLink(items: any[]): any[] {
        return items.map(item => {
            if (item.items && item.items.length > 0) {
                const { routerLink, ...rest } = item;
                rest.items = this.adjustRouterLink(item.items);
                return rest;
            } else return item;
        });
    }
    /**
     * @author Ministerio de cultura
     * Transforma un array de tipo MenuItem[] a MegaMenuItem[].
     * @param itemsToMenu - El array original de tipo MenuItem[].
     * @createdate 2024-12-27
    */
    transformMenuItems(itemsToMenu: MenuItem[]): MegaMenuItem[] {
        return itemsToMenu.map((item) => {
            if (!item.items) {
                return {
                    label: item.label,
                    icon: item.icon,
                    routerLink: item.routerLink,
                    command: item.command,
                } as MegaMenuItem;
            }
            const groupedItems = this.groupItems(item.items);
            return {
                label: item.label,
                icon: item.icon,
                items: groupedItems,
                routerLink: item.routerLink
            } as MegaMenuItem;
        });
    }
    /**
      * @author Ministerio de cultura
      * Aquí se agrupan en un tamaño arbitrario de 7 elementos por grupo.
      * @createdate 2024-12-27
      * @param items - Los subitems a agrupar.
    */
    groupItems(items: MenuItem[]): { items: MenuItem[] }[][] {
        const grouped: { items: MenuItem[] }[][] = [];
        const groupSize = 7;
        for (let i = 0; i < items.length; i += groupSize) grouped.push([{ items: items.slice(i, i + groupSize) }]);
        return grouped;
    }
    /**
      * @author Ministerio de cultura
      * @createdate 2024-10-27
      * Metodo que cierra la sesion en el sistema.
    */
    onClickLogoutMenu(): void {
        this.alertService.showConfirmAlert({ html: '¿Desea cerrar sesión en el sistema?' }).then(confirm => {
            if (confirm.isConfirmed) {
                this.authService.logout().subscribe(_ => {
                    this.authService.clearTokenWatcher();
                    this.storage.clear('local');
					this.storage.clear('session');
                    this.router.navigate(['/']);
                });
            }
        })
    }
    /**
      * @author Ministerio de cultura
      * @createdate 2024-10-27
      * Metodo que abre la modal para seleccionar la vigencia.
    */
    onClickShowValidities(): void {
        this.dynamicDialogRef = this.dialogService.open(DialogValidityComponent, {
            width: '90vw',
            modal: true,
            dismissableMask: true,
            closable: false,
            contentStyle: { 'overflow': 'visible' },
        });
    }
}
// this.itemsToMenu = [
//   {
//     label: 'Inicio',
//     icon: 'pi pi-home',
//     routerLink: ['/sigp/modulos/index']
//   },
//   {
//     label: 'Configuración',
//     icon: 'pi pi-cog',
//     items: [
//       { label: 'Pais', routerLink: ['/sigp/modulos/configuracion/pais'] },
//       { label: 'Dependencias', routerLink: ['/sigp/modulos/configuracion/dependencias'] },
//       { label: 'Grupos', routerLink: ['/sigp/modulos/configuracion/grupos'] },
//       { label: 'Recursos', routerLink: ['/sigp/modulos/configuracion/recursos'] },
//       { label: 'Fuentes', routerLink: ['/sigp/modulos/configuracion/fuentes'] },
//       { label: 'Entidades', routerLink: ['/sigp/modulos/configuracion/entidades'] },
//       { label: 'Vigencia', routerLink: ['/sigp/modulos/configuracion/vigencia'] },
//       { label: 'Tipo Documento', routerLink: ['/sigp/modulos/configuracion/tipo-documento'] },
//       { label: 'Sexo', routerLink: ['/sigp/modulos/configuracion/sexo'] },
//       { label: 'Códigos UNSPSC', routerLink: ['/sigp/modulos/configuracion/codigos-unspsc'] },
//       { label: 'Tipo Contrato Prestación', routerLink: ['/sigp/modulos/configuracion/tipo-contrato-prestacion'] },
//       { label: 'Tipo Proyecto', routerLink: ['/sigp/modulos/configuracion/tipo-proyecto'] },
//       { label: 'Conceptos de Gastos', routerLink: ['/sigp/modulos/configuracion/conceptos-gastos'] },
//       { label: 'Modalidad de Selección', routerLink: ['/sigp/modulos/configuracion/modalidad-seleccion'] },
//       { label: 'Tipo de Autenticación', routerLink: ['/sigp/modulos/configuracion/tipo-autenticacion'] },
//       { label: 'Situación', routerLink: ['/sigp/modulos/configuracion/situacion'] },
//       { label: 'Tipo de Contrato', routerLink: ['/sigp/modulos/configuracion/tipo-contrato'] },
//       { label: 'Tipo de Rubros', routerLink: ['/sigp/modulos/configuracion/tipo-rubros'] },
//       { label: 'Rubros', routerLink: ['/sigp/modulos/configuracion/rubros'] },
//       { label: 'Clasificación adquisición', routerLink: ['/sigp/modulos/configuracion/clasificacion-adquisicion'] }
//     ]
//   },
//   {
//     label: 'Administración',
//     icon: 'pi pi-users',
//     items: [
//       { label: 'Roles', routerLink: ['/sigp/modulos/administracion/roles'] },
//       { label: 'Gestión de Menú', routerLink: ['/sigp/modulos/administracion/gestion-menu'] },
//       { label: 'Gestión de APIs', routerLink: ['/sigp/modulos/administracion/gestion-apis'] },
//       { label: 'Permisos por Rol', routerLink: ['/sigp/modulos/administracion/permisos-por-rol'] },
//       { label: 'Usuarios del Sistema', routerLink: ['/sigp/modulos/administracion/usuarios-sistema'] },
//       { label: 'Tipo de Autenticación', routerLink: ['/sigp/modulos/administracion/tipo-autenticacion'] }
//     ],
//   },
//   {
//     label: 'Programación',
//     icon: 'pi pi-dollar',
//     items: [
//       { label: 'Proyectos', routerLink: ['/sigp/modulos/programacion/proyectos'] },
//       { label: 'Configurar Proyectos', routerLink: ['/sigp/modulos/programacion/configurar-proyectos'] },
//       { label: 'Programar PAA', routerLink: ['/sigp/modulos/programacion/programar-paa'] }
//     ],
//   },
//   {
//     label: 'CDP',
//     icon: 'pi pi-clone',
//     items: [
//       { label: 'Solicitar CDP', routerLink: ['/sigp/modulos/cdp/solicitar-cdp'] },
//       { label: 'Mis CDP', routerLink: ['/sigp/modulos/cdp/mis-cdps'] }
//     ],
//   },
//   {
//     label: 'Mensajería',
//     icon: 'pi pi-envelope',
//     items: [
//       { label: 'Listado Solicitudes', routerLink: ['/sigp/modulos/mensajeria/listado-solicitudes'] },
//       { label: 'Gestión de Flujos', routerLink: ['/sigp/modulos/mensajeria/gestion-flujos'] },
//       { label: 'Tipo de Flujos', routerLink: ['/sigp/modulos/mensajeria/tipo-flujos'] },
//       { label: 'Roles de Flujos', routerLink: ['/sigp/modulos/mensajeria/roles-flujos'] },
//       { label: 'Activación de Flujos', routerLink: ['/sigp/modulos/mensajeria/activacion-flujos'] }
//     ]
//   },
//   {
//     label: 'Indicadores',
//     icon: 'pi pi-list',
//     items: [
//       { label: 'Catálogo de Indicadores', routerLink: ['/sigp/modulos/indicadores/catalogo-indicadores'] },
//       { label: 'Lista de Indicadores', routerLink: ['/sigp/modulos/indicadores/lista-indicadores'] },
//       { label: 'Configurar Indicadores', routerLink: ['/sigp/modulos/indicadores/configurar-indicadores'] }
//     ]
//   },
//   {
//     label: 'Reportes',
//     icon: 'pi pi-chart-bar',
//     items: [
//       { label: 'Exportar PAA', routerLink: ['/sigp/modulos/reportes/exportar-paa'] }
//     ]
//   },
//   {
//     label: 'Mi perfil',
//     icon: 'pi pi-user',
//     items: [
//       { label: 'Mi perfil', routerLink: ['/sigp/modulos/perfil/mi-perfil'] }
//     ]
//   },
//   {
//     label: 'Vigencias',
//     icon: 'pi pi-cog',
//     command: () => {
//       this.onClickShowValidities();
//     }
//   },
//   {
//     label: 'Cerrar Sesión',
//     icon: 'pi pi-sign-out',
//     command: () => {
//       this.onClickLogoutMenu();
//     }
//   }
// ];

// this.items =
// [
//   {
//     label: 'Inicio',
//     icon: 'pi pi-home',
//     routerLink: ['/sigp/modulos/index']
//   },
//   {
//     label: 'Configuración',
//     icon: 'pi pi-cog',
//     items: [
//       [
//         {
//           items: [
//             { label: 'Dependencias', routerLink: ['/sigp/modulos/configuracion/dependencias'] },
//             { label: 'Grupos', routerLink: ['/sigp/modulos/configuracion/grupos'] },
//             { label: 'Recursos', routerLink: ['/sigp/modulos/configuracion/recursos'] },
//             { label: 'Fuentes', routerLink: ['/sigp/modulos/configuracion/fuentes'] },
//             { label: 'Entidades', routerLink: ['/sigp/modulos/configuracion/entidades'] },
//             { label: 'Vigencia', routerLink: ['/sigp/modulos/configuracion/vigencia'] },
//             { label: 'Estado Vigencia Futura', routerLink: ['/sigp/modulos/configuracion/estado-vigencia-futura'] }
//           ]
//         }
//       ],
//       [
//         {
//           items: [
//             { label: 'Tipo Documento', routerLink: ['/sigp/modulos/configuracion/tipo-documento'] },
//             { label: 'Sexo', routerLink: ['/sigp/modulos/configuracion/sexo'] },
//             { label: 'Códigos UNSPSC', routerLink: ['/sigp/modulos/configuracion/codigos-unspsc'] },
//             { label: 'Situación', routerLink: ['/sigp/modulos/configuracion/situacion'] },
//             { label: 'Tipo Contrato Prestación', routerLink: ['/sigp/modulos/configuracion/tipo-contrato-prestacion'] },
//             { label: 'Clasificación adquisición', routerLink: ['/sigp/modulos/configuracion/clasificacion-adquisicion'] }
//           ]
//         }
//       ],
//       [
//         {
//           items: [
//             { label: 'Conceptos de Gastos', routerLink: ['/sigp/modulos/configuracion/conceptos-gastos'] },
//             { label: 'Modalidad de Selección', routerLink: ['/sigp/modulos/configuracion/modalidad-seleccion'] },
//             { label: 'Tipo de Contrato', routerLink: ['/sigp/modulos/configuracion/tipo-contrato'] },
//             { label: 'Tipo de Rubros', routerLink: ['/sigp/modulos/configuracion/tipo-rubros'] },
//             { label: 'Rubros', routerLink: ['/sigp/modulos/configuracion/rubros'] },
//             { label: 'Unidad de Medida Contratos', routerLink: ['/sigp/modulos/configuracion/unidad-medida-contratos'] },
//           ]
//         }
//       ]
//     ]
//   },
//   {
//     label: 'Administración',
//     icon: 'pi pi-users',
//     items: [
//       [
//         {
//           items: [
//             { label: 'Roles', routerLink: ['/sigp/modulos/administracion/roles'] },
//             { label: 'Gestión de Menú', routerLink: ['/sigp/modulos/administracion/gestion-menu'] },
//             { label: 'Gestión de APIs', routerLink: ['/sigp/modulos/administracion/gestion-apis'] },
//             { label: 'Tipo de Autenticación', routerLink: ['/sigp/modulos/administracion/tipo-autenticacion'] }
//           ]
//         }
//       ],
//       [
//         {
//           items: [
//             { label: 'Permisos por Rol', routerLink: ['/sigp/modulos/administracion/permisos-por-rol'] },
//             { label: 'Usuarios del Sistema', routerLink: ['/sigp/modulos/administracion/usuarios-sistema'] }
//           ]
//         }
//       ]
//     ]
//   },
//   {
//     label: 'Programación',
//     icon: 'pi pi-dollar',
//     items: [
//       [
//         {
//           items: [
//             { label: 'Proyectos', routerLink: ['/sigp/modulos/programacion/proyectos'] },
//             { label: 'Configurar Proyectos', routerLink: ['/sigp/modulos/programacion/configurar-proyectos'] },
//             { label: 'Programar PAA', routerLink: ['/sigp/modulos/programacion/programar-paa'] }
//           ]
//         }
//       ]
//     ]
//   },
//   {
//     label: 'CDP',
//     icon: 'pi pi-clone',
//     items: [
//       [
//         {
//           items: [
//             { label: 'Solicitar CDP', routerLink: ['/sigp/modulos/cdp/solicitar-cdp'] },
//             { label: 'Mis CDP', routerLink: ['/sigp/modulos/cdp/mis-cdps'] }
//           ]
//         }
//       ]
//     ]
//   },
//   {
//     label: 'Mensajería',
//     icon: 'pi pi-envelope',
//     items: [
//       [
//         {
//           items: [
//             { label: 'Listado Solicitudes', routerLink: ['/sigp/modulos/mensajeria/listado-solicitudes'] },
//             { label: 'Gestión de Flujos', routerLink: ['/sigp/modulos/mensajeria/gestion-flujos'] },
//             { label: 'Tipo de Flujos', routerLink: ['/sigp/modulos/mensajeria/tipo-flujos'] },
//             { label: 'Roles de Flujos', routerLink: ['/sigp/modulos/mensajeria/roles-flujos'] },
//             { label: 'Activación de Flujos', routerLink: ['/sigp/modulos/mensajeria/activacion-flujos'] }
//           ]
//         }
//       ]
//     ]
//   },
//   {
//     label: 'Indicadores',
//     icon: 'pi pi-list',
//     items: [
//       [
//         {
//           items: [
//             { label: 'Catálogo de Indicadores', routerLink: ['/sigp/modulos/indicadores/catalogo-indicadores'] },
//             { label: 'Tipo de Cálculo', routerLink: ['/sigp/modulos/indicadores/tipo-calculo-indicadores'] },
//             { label: 'Tipo de Medición', routerLink: ['/sigp/modulos/indicadores/tipo-medicion-indicadores'] },
//             { label: 'Unidad de Medida', routerLink: ['/sigp/modulos/indicadores/unidad-medida-indicadores'] },
//             { label: 'Frecuencia de Medición', routerLink: ['/sigp/modulos/indicadores/frecuencia-medicion-indicadores'] },
//             { label: 'Lista de Indicadores', routerLink: ['/sigp/modulos/indicadores/lista-indicadores'] },
//             { label: 'Configurar Indicadores', routerLink: ['/sigp/modulos/indicadores/configurar-indicadores'] }
//           ]
//         }
//       ]
//     ]
//   },
//   {
//     label: 'Reportes',
//     icon: 'pi pi-chart-bar',
//     items: [
//       [
//         {
//           items: [
//             { label: 'Exportar PAA', routerLink: ['/sigp/modulos/reportes/exportar-paa'] }
//           ]
//         }
//       ]
//     ]
//   }
// ];